<template lang="pug">
    section.payment-step
        .alert.mt-0
            p {{ $t('Total amount') }}
            b {{ grandTotal | moneyFormat(currency) }}
        el-form-item.no-margin(v-if="form.paymentMethod" :label="$t('Payment Method')" prop="paymentMethod.name")
            el-input(v-model="form.paymentMethod.name")

        el-divider

        .flex-row
            el-form-item
                el-checkbox(v-model="form.notify" border) {{ $t('Send order confirmation') }}
                //- el-tooltip(:content="$t('Sends an order confirmation email to the customer')" placement="top")
                //-     i.el-icon-info.ml-1
            el-form-item
                el-checkbox(v-model="form.isReservation" border) {{ $t('Reservation') }}
                el-tooltip(:content="$t('Creates the order with pending status')" placement="top")
                    i.el-icon-info.ml-1

        transition(name="slide-decent-vertical")
            el-form-item.no-margin(v-if="form.notify" :label="$t('Optional additional text for the confirmation email')")
                el-input(
                    type="textarea"
                    v-model="form.confirmationCommentary"
                    :rows="3"
                )
</template>

<i18n>
{
    "de": {
        "Invoice": "Rechnung",
        "Total amount": "Gesamtbetrag",
        "Payment Method": "Zahlungsmethode",
        "Reservation": "Reservierung",
        "Send order confirmation": "Bestellbestätigung versenden",
        "Creates the order with pending status": "Erstellt die Bestellung mit Status 'Ausstehend'",
        "Sends an order confirmation email to the customer": "Sendet eine Bestellbestätigung per E-Mail an den Kunden",
        "Optional additional text for the confirmation email": "Optionaler Zusatztext für die Bestätigungs-E-Mail",
        "Additional text for email": "Zusatztext in der E-Mail"
    }
}
</i18n>

<script>
import { useSetupStore } from '@/stores';
import pinia from '@/pinia';

export default {
    name: 'PaymentStep',
    props: {
        form: {
            type: Object,
            required: true,
        },
        rules: {
            type: Object,
            required: true,
        },
        grandTotal: {
            type: Number,
            required: true
        },
    },
    computed: {
        setupStore() {
            return useSetupStore(pinia);
        },
        activeCms() {
            return this.setupStore.activeCms;
        },
        customerGroup() {
            const customer = this.form.purchaser.customer
            return _.get(customer, 'customerGroup') || _.get(this.activeCms, 'shop.defaultCustomerGroup')
        },
        currency() {
            return _.get(this.customerGroup, 'currency.iso4217') || 'EUR'
        },
    },
    mounted() {
        if (!this.form.paymentMethod) {
            this.$set(this.form, 'paymentMethod', { name: this.$t('Invoice') })
        }
    },
};
</script>
